import { useCallback, useEffect, useId, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const CLOSE_DELAY_MS = 150;

function NhStyleFingerprintHoverInfo({ ariaLabel, popupLabel, children }) {
  const popoverId = useId();
  const closeTimer = useRef(null);
  const [anchorElement, setAnchorElement] = useState(null);
  const open = Boolean(anchorElement);

  const cancelClose = useCallback(() => {
    if (closeTimer.current !== null) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  }, []);

  const handleOpen = useCallback((event) => {
    cancelClose();
    setAnchorElement(event.currentTarget);
  }, [cancelClose]);

  const handleClose = useCallback(() => {
    cancelClose();
    closeTimer.current = setTimeout(() => {
      closeTimer.current = null;
      setAnchorElement(null);
    }, CLOSE_DELAY_MS);
  }, [cancelClose]);

  useEffect(() => () => {
    if (closeTimer.current !== null) {
      clearTimeout(closeTimer.current);
    }
  }, []);

  return (
    <>
      <IconButton
        size="small"
        aria-label={ariaLabel}
        aria-expanded={open}
        aria-describedby={open ? popoverId : undefined}
        onClick={handleOpen}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        onFocus={handleOpen}
        onBlur={handleClose}
        sx={{ color: 'text.secondary', p: 0.25 }}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popper
        open={open}
        anchorEl={anchorElement}
        placement="bottom-start"
        disablePortal
        sx={{ zIndex: (theme) => theme.zIndex.tooltip }}
      >
        <Box
          id={popoverId}
          component="section"
          aria-label={popupLabel}
          onMouseEnter={cancelClose}
          onMouseLeave={handleClose}
          onFocus={cancelClose}
          onBlur={handleClose}
          sx={{ pt: 0.5 }}
        >
          <Paper elevation={8} sx={{ maxWidth: 480, p: 2 }}>
            {children}
          </Paper>
        </Box>
      </Popper>
    </>
  );
}

NhStyleFingerprintHoverInfo.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  popupLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default NhStyleFingerprintHoverInfo;
